import { useEffect, useState, useReducer } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/authContext"
import RemoteControl from "./RemoteControl";
import UserInfos from "./UserInfos";
import QuestionInfos from "./QuestionInfos";
import QuestionImage from "./QuestionImage";
import questions from "../../assets/questions/questions.dr.json";

const initialAnswers = { 1: null, 2: null, 3: null, 4: null };
const hideWarning = ()=>{
  document.getElementById("landscape-warning-message").style.display = 'none';
}
function answersReducer(state, action) {
  switch (action.type) {
    case "reset":
      return initialAnswers;
    case "validate":
      return initialAnswers;
    default:
      console.log({ ...state, [action.type]: action.type });
      return { ...state, [action.type]: action.type };
  }
}
function Question({
  match: {
    params: { serieNbr, questionNbr },
  },
  history,
}) {
  const {logout} = useAuth()
  // const [questionNbr, setQuestionNbr] = useState(1);
  const correctAnswer = new URLSearchParams(useLocation().search).get(
    "correctAnswer"
  );
  const [isAudioFinished, setIsAudioFinished] = useState(false);
  const [questionMode, setQuestionMode] = useState("play");
  const [chosenAnswers, dispatchAnswers] = useReducer(
    answersReducer,
    initialAnswers
  );
  const setQuestionNbr = (callback, mode = "play") => {
    // if (mode !== "back") {
    const question = callback(parseInt(questionNbr));
    let answers = JSON.parse(sessionStorage.getItem("__users_answers__")) || [];
    sessionStorage.setItem(
      "__users_answers__",
      JSON.stringify([...answers, chosenAnswers])
    );
    history.push(`/serie/${serieNbr}/question/${question}`);
    // }
  };

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.keyCode === 32) {
        setQuestionMode((m) => (m === "play" ? "pause" : "play"));
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  useEffect(() => {
    dispatchAnswers({ type: "validate" });
    setQuestionMode("play");
    if (questionNbr > 40) {
      history.push(`/serie/${serieNbr}/result/`);
    }
  }, [questionNbr, serieNbr, history]);

  return (
    <>
      <div className="top-menu">
        <Link to="/" title="الرجوع الى القائمة الرئيسية">
          <img src="assets/home.svg" style={{ height: "1.5rem" }} alt="home" />
        </Link>
        {/* <Link to={`/serie/${serieNbr}/question/${parseInt(questionNbr) - 1}`}>
          <img
            src="assets/go-back.svg"
            style={{ height: "1.5rem" }}
            alt="back to the previous question"
          />
        </Link> */}
        <Link to={`/serie/${serieNbr}/result/`} title="النتيجة">
          {correctAnswer ? (
            <img
              src="assets/go-back.svg"
              style={{ height: "1.5rem" }}
              alt="home"
            />
          ) : (
            <img
              src="assets/stop.svg"
              style={{ height: "1.5rem" }}
              alt="home"
            />
          )}
        </Link>
        <span
          style={{ cursor: "pointer" }}
          onClick={() =>
            setQuestionMode((m) => (m === "play" ? "pause" : "play"))
          }
          title="توقيف السؤال"
        >
          {questionMode === "pause" ? (
            <img
              src="assets/play.svg"
              style={{ height: "1.5rem" }}
              alt="home"
            />
          ) : (
            <img
              src="assets/pause.svg"
              style={{ height: "1.5rem" }}
              alt="home"
            />
          )}
        </span>
        <Link to="/" style={{marginLeft:"auto", display:"flex", textDecoration:"none", color:"#000"}} onClick={logout}>
          الخروج &nbsp;
          <img
                src="assets/logout.svg"
                style={{ height: "1.5rem" }}
                alt="home"
              />
            </Link>
      </div>
      {questionNbr <= 40 && (
        <div id="question-page">
          <QuestionImage {...{ questionNbr, serieNbr }} />
          <RemoteControl
            {...{
              setQuestionNbr,
              isAudioFinished,
              chosenAnswers,
              dispatchAnswers,
              questionNbr,
              correctAnswer
            }}
          />
          {correctAnswer?<h3 className="question-explanation">{questions[`serie${serieNbr}`][questionNbr].com}</h3>:<QuestionInfos
            {...{
              questionNbr,
              setQuestionNbr,
              serieNbr,
              isAudioFinished,
              setIsAudioFinished,
              questionMode,
            }}
          />}
          <UserInfos />
        </div>
      )}
      <div id="landscape-warning-message" onClick={hideWarning}>
      <span style={{alignSelf: "flex-end", marginRight: "3%"}}>x</span>
      <img src="./rotate-device.gif" width="50%" height="auto" alt="please rotate your device"/></div>
    </>
  );
}

export default Question;
